// Ürün Kataloğu uygulaması store'u (Excel'den katalog + sütun kuralları + ürün eşleştirme).
// Katalog/satır sayıları küçük (≤5000) → liste ve ızgara tek çağrıda yüklenir,
// sayfalama/arama istemci tarafında.

const base = (vm) => vm.endpoint.get('ecommerce_product_catalog')

const state = () => ({
    app: {installed: false, enabled: false},
    catalogs: [],
})

const actions = {
    async fetchCatalogs({commit}, params = {}) {
        const res = await this._vm.axios.get(base(this._vm) + '/catalog', {params})
        const data = res?.data?.data ?? {}
        commit('setList', data)
        return data
    },
    async showCatalog(_, {id}) {
        const res = await this._vm.axios.get(base(this._vm) + '/catalog/' + id)
        return res?.data?.data
    },
    async createCatalog(_, {data}) {
        const res = await this._vm.axios.post(base(this._vm) + '/catalog', data)
        return res?.data
    },
    async updateCatalog(_, {id, data}) {
        const res = await this._vm.axios.put(base(this._vm) + '/catalog/' + id, data)
        return res?.data
    },
    async deleteCatalog(_, {id}) {
        const res = await this._vm.axios.delete(base(this._vm) + '/catalog/' + id)
        return res?.data
    },
    async syncColumns(_, {id, columns}) {
        const res = await this._vm.axios.put(base(this._vm) + '/catalog/' + id + '/columns', {columns})
        return res?.data
    },
    async matchCatalog(_, {id, all = false}) {
        const res = await this._vm.axios.post(base(this._vm) + '/catalog/' + id + '/match', {all})
        return res?.data
    },
    async previewCatalog(_, {id}) {
        const res = await this._vm.axios.get(base(this._vm) + '/catalog/' + id + '/preview')
        return res?.data?.data
    },
    async exportCatalog(_, {id}) {
        const res = await this._vm.axios.get(base(this._vm) + '/catalog/' + id + '/export', {responseType: 'blob'})
        return res?.data
    },

    // ── Satırlar ─────────────────────────────────────────────────────────
    async fetchItems(_, {id}) {
        const res = await this._vm.axios.get(base(this._vm) + '/catalog/' + id + '/item')
        return res?.data?.data?.items ?? []
    },
    async saveItem(_, {catalogId, itemId = null, data}) {
        const url = base(this._vm) + '/catalog/' + catalogId + '/item' + (itemId ? '/' + itemId : '')
        const res = itemId ? await this._vm.axios.put(url, data) : await this._vm.axios.post(url, data)
        return res?.data
    },
    async deleteItem(_, {catalogId, itemId}) {
        const res = await this._vm.axios.delete(base(this._vm) + '/catalog/' + catalogId + '/item/' + itemId)
        return res?.data
    },
    async bulkItems(_, {catalogId, ids, action}) {
        const res = await this._vm.axios.post(base(this._vm) + '/catalog/' + catalogId + '/item/bulk', {ids, action})
        return res?.data
    },
    async reorderItems(_, {catalogId, ids}) {
        const res = await this._vm.axios.post(base(this._vm) + '/catalog/' + catalogId + '/item/reorder', {ids})
        return res?.data
    },
    async searchProducts(_, {q = '', ids = []}) {
        const res = await this._vm.axios.get(base(this._vm) + '/product-search', {params: {q, ids}})
        return res?.data?.data ?? []
    },

    // ── Excel içe aktarma ────────────────────────────────────────────────
    async uploadImport(_, {file, catalogId = null}) {
        const fd = new FormData()
        fd.append('file', file)
        if (catalogId) fd.append('catalog_id', catalogId)
        const res = await this._vm.axios.post(base(this._vm) + '/import/upload', fd, {headers: {'Content-Type': 'multipart/form-data'}})
        return res?.data
    },
    async readImport(_, payload) {
        const res = await this._vm.axios.post(base(this._vm) + '/import/read', payload)
        return res?.data
    },
    async commitImport(_, payload) {
        const res = await this._vm.axios.post(base(this._vm) + '/import/commit', payload)
        return res?.data
    },
}

const mutations = {
    setList(state, data) {
        state.app = data?.app ?? {installed: false, enabled: false}
        state.catalogs = data?.catalogs ?? []
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}
